import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { MenuScene } from './scenes/MenuScene';
import { GameScene } from './scenes/GameScene';
import { GameOverScene } from './scenes/GameOverScene';
import { VictoryScene } from './scenes/VictoryScene';

/**
 * HD Text Resolution Hook
 * Forces all Phaser Text objects to render at High-DPI (2x-3x) resolution
 * eliminating all blurry or fuzzy font edges on mobile and desktop Retina displays.
 */
const hdResolution = Math.max(2, Math.min(window.devicePixelRatio || 2, 3));
const origText = Phaser.GameObjects.GameObjectFactory.prototype.text;
Phaser.GameObjects.GameObjectFactory.prototype.text = function (x, y, text, style) {
  const newStyle = Object.assign({ resolution: hdResolution }, style);
  if (style && (style.resolution === undefined || style.resolution === 0)) {
    newStyle.resolution = hdResolution;
  }
  return origText.call(this, x, y, text, newStyle);
};

/**
 * Game Configuration for Mobile Android & Web
 * Configured for portrait mode (9:16 ratio) with smooth 60 FPS physics
 * and full High-Definition (HD) WebGL anti-aliased rendering.
 */
const config = {
  type: Phaser.AUTO,
  parent: 'game-container',
  backgroundColor: '#020617',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: 480,
    height: 854,
  },
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { y: 1350 },
      debug: false,
      fps: 60
    }
  },
  input: {
    activePointers: 3 // Allows multi-touch for simultaneous moving and anti-gravity flipping
  },
  render: {
    pixelArt: false,
    antialias: true,
    antialiasGL: true,
    roundPixels: false,
    powerPreference: 'high-performance',
    mipmapFilter: 'LINEAR_MIPMAP_LINEAR'
  },
  scene: [BootScene, MenuScene, GameScene, GameOverScene, VictoryScene]
};

// Initialize the game instance
const game = new Phaser.Game(config);
window.game = game;
window.Phaser = Phaser;

// Prevent accidental context menus and gesture zooms on mobile touch
window.addEventListener('contextmenu', (e) => e.preventDefault());
document.addEventListener('gesturestart', (e) => e.preventDefault());

